import superService from "./superService";
import MiniApp from "./miniGameContent/miniApp";
import WxApi from "./miniGameContent/wx/wxApi";
import H5Api from "./miniGameContent/h5/h5Api";
import TtApi from "./miniGameContent/tt/ttApi";
import NativeApi from "./miniGameContent/native/native";
import ksApi from "./miniGameContent/ks/KSAPI";
import VivoApi from "./miniGameContent/vivo/vivoApi";
import OppoApi from "./miniGameContent/oppo/oppoApi";
import gameConfig from "../configs/gameConfig";
import {services} from "../gameEngine";
import H5_4399 from "./miniGameContent/h5_4399/h5_4399";
import gameBox4399 from "./miniGameContent/gameBox4399/gameBox4399";

export default class MiniGameService extends superService {

    protected className: string = '游戏平台服务';

    private static m_MiniAppClass: typeof MiniApp | any = null;
    private m_miniApp: MiniApp = null;

    constructor() {
        super();
        if (window.hasOwnProperty('gamebox')) {
            console.warn('4399游戏盒子');
            MiniGameService.m_MiniAppClass = gameBox4399;
            return;
        }
        //平台
        switch (cc.sys.platform) {
            case cc.sys.WECHAT_GAME_SUB:
            case cc.sys.WECHAT_GAME: {
                MiniGameService.m_MiniAppClass = ksApi;
                break;
            }
            case cc.sys.BYTEDANCE_GAME:
            case cc.sys.BYTEDANCE_GAME_SUB: {
                MiniGameService.m_MiniAppClass = TtApi;
                break;
            }
            case cc.sys.VIVO_GAME: {
                MiniGameService.m_MiniAppClass = VivoApi;
                break;
            }
            case cc.sys.OPPO_GAME: {
                MiniGameService.m_MiniAppClass = OppoApi;
                break;
            }
            default: {
                if (cc.sys.isNative) {
                    MiniGameService.m_MiniAppClass = NativeApi;
                } else {
                    if (cc.sys.platform == 3 || cc.sys.platform == 4) {
                        MiniGameService.m_MiniAppClass = ksApi;
                    } else {
                        if (window.hasOwnProperty('h5api')) {
                            MiniGameService.m_MiniAppClass = H5_4399;
                        } else if (window.hasOwnProperty('gamebox')) {
                            MiniGameService.m_MiniAppClass = gameBox4399;
                        } else {
                            MiniGameService.m_MiniAppClass = H5Api;
                        }
                    }
                }
                break;
            }
        }
    }

    async loadService(): Promise<void> {
        await super.loadService();
        this.m_miniApp = <MiniApp>new MiniGameService.m_MiniAppClass();
        //验证授权
        this.m_miniApp.validAppId();
        //预先加载
        this.m_miniApp.preCreateUnits();
        //
        return Promise.resolve();
    }

    getAppApiInstance() {
        return this.m_miniApp;
    }

    onTimerStart() {
        console.log('jhsdk time start');
        this.onFullVideoEvent();
    }

    private m_fullTouchTime: boolean;

    //推出全屏广告
    onPushFullVideo() {
        console.log('jhsdk push');
        if (!this.m_fullTouchTime) return;
        //
        this.getAppApiInstance().fullScreenVideo().then();
        //
        this.onResetFullVideoTime();
    }

    //全屏视频广告事件触发
    protected onFullVideoEvent() {
        //开关
        if (gameConfig.FULL_SCREEN_VIDEO_TIME <= 0) {
            return;
        }
        let app = this.getAppApiInstance();
        if (!app.fullScreenVideo) {
            console.warn('此平台未接入全屏视频广告 - ', services().ossSrv.getPlatform());
            return;
        }
        //进入CD
        this.onResetFullVideoTime();
    }

    //进入CD
    protected onResetFullVideoTime() {
        //初始化
        this.m_fullTouchTime = false;
        //CD计时
        setInterval(() => {
            this.m_fullTouchTime = true;
        }, gameConfig.FULL_SCREEN_VIDEO_TIME * 1e3);
    }

    static getMiniGameAppStatic(): typeof MiniApp {
        return MiniGameService.m_MiniAppClass;
    }
}